import { render, staticRenderFns } from "./TrendingPosts.vue?vue&type=template&id=b8cd770a&scoped=true&"
import script from "./TrendingPosts.vue?vue&type=script&lang=js&"
export * from "./TrendingPosts.vue?vue&type=script&lang=js&"
import style0 from "./TrendingPosts.vue?vue&type=style&index=0&id=b8cd770a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cd770a",
  null
  
)

export default component.exports